module.exports = __webpack_public_path__ + "img/Weapon_51.df7d2747.png";